export default {
  excelButton: {
    marginTop: 10,
  },
};
